module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('header', {
    staticClass: "calendar admin-calendar static"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "date-picker"
  }, [_c('div', {
    ref: "calendar_admin",
    staticClass: "date-picker-dates owl-carousel",
    attrs: {
      "id": "calendar_admin"
    }
  }, _vm._l((_vm.dias), function(dia, idx) {
    return _c('div', {
      key: idx,
      staticClass: "item",
      class: {
        current: idx === _vm.idxDiaActivo
      }
    }, [_c('a', {
      staticClass: "cutoff-date-option",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setDiaActivo(idx)
        }
      }
    }, [_c('div', {
      staticClass: "date"
    }, [_c('div', {
      staticClass: "day-of-week mobile"
    }, [_vm._v("\n              " + _vm._s(_vm._f("diaNombreMobile")(dia)) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "day-of-week desktop"
    }, [_vm._v("\n              " + _vm._s(_vm._f("diaNombreDesktop")(dia)) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "day-of-month"
    }, [_vm._v("\n              " + _vm._s(_vm._f("diaFormateado")(dia)) + "\n              ")])])])])
  }))])])])])]), _vm._v(" "), _c('header', {
    staticClass: "static"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "tabs-manager"
  }, _vm._l((_vm.estados), function(estado, idx) {
    return (estado.titulo) ? _c('li', {
      class: {
        active: _vm.idxEstadoActivo === idx
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setEstadoActivo(idx)
        }
      }
    }, [_vm._v("\n          " + _vm._s(estado.titulo) + "\n        ")])]) : _vm._e()
  }))])]), _vm._v(" "), _c('section', {
    staticClass: "section manager-content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-2 aside-manager"
  }, [_c('div', {
    staticClass: "box-aside line-top smart-form"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-aside-body resume stats"
  }, [_c('div', {
    staticClass: "stats-item"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('span', {
    staticClass: "stats-number pending"
  }, [_vm._v(_vm._s(_vm.contadorPedidosPendientes))])]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "stats-item"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('span', {
    staticClass: "stats-number oncourse"
  }, [_vm._v(_vm._s(_vm.contadorPedidosEnCurso))])]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "stats-item"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('span', {
    staticClass: "stats-number process"
  }, [_vm._v(_vm._s(_vm.contadorPedidosProcesados))])]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "stats-item"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('span', {
    staticClass: "stats-number process"
  }, [_vm._v(_vm._s(_vm.contadorPedidosDespachados))])]), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "stats-item"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('span', {
    staticClass: "stats-number canceled"
  }, [_vm._v(_vm._s(_vm.contadorPedidosCancelados))])]), _vm._v(" "), _vm._m(5)])])]), _vm._v(" "), _c('div', {
    staticClass: "box-aside-body resume-total"
  }, [_c('h3', {
    staticClass: "total-number"
  }, [_vm._v(_vm._s(_vm._f("formatearMoneda")(_vm.montoTotalEntregas)))]), _vm._v(" "), _c('span', {
    staticClass: "total-label"
  }, [_vm._v("Total del día")])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "box-aside-body text-center"
  }, [_c('a', {
    staticClass: "btn btn-outline-grey-green",
    on: {
      "click": function($event) {
        _vm.verResumen = !_vm.verResumen
      }
    }
  }, [_vm._v("Mostrar resumen")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "btn-link margin-top-10 deco-dotted pull-left",
    attrs: {
      "to": "/historicoentregas"
    }
  }, [_vm._v("Ver histórico de entregas")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-9 col-lg-10"
  }, [_c('div', {
    staticClass: "box-style line-top smart-form"
  }, [_c('div', {
    staticClass: "box-header-lg"
  }, [_c('h1', [_vm._v("ENTREGAS " + _vm._s(_vm._f("toUpper")(_vm.estados[_vm.idxEstadoActivo].text)) + " PARA LA FECHA")]), _vm._v(" "), _c('div', {
    staticClass: "box-header-aside bha-selector"
  }, [_c('label', [_vm._v("EMPRESA")]), _vm._v(" "), _c('div', {
    staticClass: "select form-ghost"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.empresaActiva),
      expression: "empresaActiva"
    }],
    ref: "selectEmpresa",
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.empresaActiva = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("TODAS LAS EMPRESAS")]), _vm._v(" "), _vm._l((_vm.empresas), function(empresa) {
    return _c('option', {
      key: empresa._id,
      domProps: {
        "value": empresa._id
      }
    }, [_vm._v(_vm._s(empresa.text))])
  })], 2), _vm._v(" "), _c('i', {
    staticClass: "fa fa fa-angle-down"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.verResumen),
      expression: "verResumen"
    }]
  }, [_c('div', {
    ref: "contenedorPivor"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.printPivot()
      }
    }
  }, [_vm._v("Imprimir")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-fill",
    on: {
      "click": function($event) {
        _vm.verResumen = false
      }
    }
  }, [_vm._v("Esconder resumen")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.verResumen),
      expression: "!verResumen"
    }],
    staticClass: "table-header form smart-form"
  }, [_c('div', {
    staticClass: "form-group col-hactions col1"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-action"
  }, [_c('select', {
    staticClass: "form-control",
    domProps: {
      "value": _vm.estadoActivo
    },
    on: {
      "change": _vm.onChangeEstadoSeleccionados
    }
  }, _vm._l((_vm.estados), function(estado) {
    return _c('option', {
      key: estado._id,
      domProps: {
        "value": estado.id
      }
    }, [_vm._v(_vm._s(estado.text))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-hactions col2"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-action"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_vm._m(9), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.entregasSeleccionadasAXls()
      }
    }
  }, [_vm._v("Descargar selección")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.entregasListadoAXls()
      }
    }
  }, [_vm._v("Descargar todo el listado")])])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_vm._m(10), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.entregasSeleccionadasAPdf()
      }
    }
  }, [_vm._v("Descargar selección")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.entregasListadoAPdf()
      }
    }
  }, [_vm._v("Descargar todo el listado")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-hactions col3"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-action"
  }, [_c('div', {
    staticClass: "button"
  }, [_c('a', {
    staticClass: "btn btn-outline-grey-green",
    staticStyle: {
      "border-bottom-width": "3px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.entregasAEtiquetas(_vm.entregasSeleccionadas)
      }
    }
  }, [_vm._v("COMANDAS")])]), _vm._v(" "), _c('div', {
    staticClass: "button"
  }, [_c('a', {
    staticClass: "btn btn-outline-grey-green",
    staticStyle: {
      "border-bottom-width": "3px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.entregasAEtiquetas(_vm.entregasSeleccionadas)
      }
    }
  }, [_vm._v("ETIQUETAS")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-hactions col4 withoutFloat"
  }, [_vm._m(12), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtroRestricciones),
      expression: "filtroRestricciones"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtroRestricciones = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ALL",
      "selected": ""
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RESTRICTIONS"
    }
  }, [_vm._v("Con Restricciones")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-group smart-accordion-default",
    attrs: {
      "id": "accordion"
    }
  }, _vm._l((_vm.entregasActivasAgrupadasHora), function(entregas, idx, a) {
    return _c('div', {
      key: a,
      staticClass: "panel panel-time"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('div', {
      staticClass: "panel-title box-header"
    }, [_c('a', {
      attrs: {
        "data-toggle": "collapse",
        "href": '#pnl-' + a
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-angle-down pull-right"
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-lg fa-angle-up pull-right"
    }), _vm._v(" "), _c('h2', [_c('b', [_vm._v(_vm._s(idx) + "hs")])])])])]), _vm._v(" "), _c('div', {
      staticClass: "panel-collapse collapse in",
      attrs: {
        "id": 'pnl-' + a
      }
    }, [_c('div', {
      staticClass: "panel-body"
    }, [_c('div', {
      staticClass: "table-container"
    }, [_c('table', {
      staticClass: "table table-hover table-stripped table-manager-time"
    }, [_c('thead', [_c('tr', [_c('th', [_c('div', {
      staticClass: "smart-form"
    }, [_c('label', {
      staticClass: "checkbox"
    }, [_c('input', {
      staticClass: "selectable",
      attrs: {
        "type": "checkbox",
        "id": 'selectable' + a
      },
      on: {
        "click": function($event) {
          _vm.marcarTodos(idx, $event)
        }
      }
    }), _vm._v(" "), _c('i')])])]), _vm._v(" "), _c('th', [_vm._v("Empresa")]), _vm._v(" "), _c('th', [_vm._v("Nro.")]), _vm._v(" "), _c('th', [_vm._v("Usuario")]), _vm._v(" "), _c('th', [_vm._v("Menú")]), _vm._v(" "), _c('th', [_vm._v("Estado")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((entregas), function(entrega) {
      return _c('tr', {
        key: entrega._id,
        staticClass: "deliveryRow",
        class: {
          deliveryRestrictions: entrega.usuario.other || entrega.usuario.alergic || entrega.usuario.vegan || entrega.usuario.vegetarian
        }
      }, [_c('td', [_c('div', {
        staticClass: "smart-form"
      }, [_c('label', {
        staticClass: "checkbox"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (entrega.seleccionada),
          expression: "entrega.seleccionada"
        }],
        staticClass: "selectable",
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(entrega.seleccionada) ? _vm._i(entrega.seleccionada, null) > -1 : (entrega.seleccionada)
        },
        on: {
          "change": function($event) {
            _vm.toggleSeleccion(entrega._id)
          },
          "__c": function($event) {
            var $$a = entrega.seleccionada,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$c) {
                $$i < 0 && (entrega.seleccionada = $$a.concat($$v))
              } else {
                $$i > -1 && (entrega.seleccionada = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              entrega.seleccionada = $$c
            }
          }
        }
      }), _vm._v(" "), _c('i')])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entrega.sucursal.empresa.razonSocial) + "-" + _vm._s(entrega.sucursal.denominacion))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entrega.numero))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entrega.usuario.displayName))]), _vm._v(" "), _c('td', [(entrega.usuario.other || entrega.usuario.alergic || entrega.usuario.vegan || entrega.usuario.vegetarian) ? _c('i', {
        staticClass: "fa fa-ban",
        attrs: {
          "title": "Tiene restricciones alimenticias"
        }
      }) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "truncate"
      }, [_vm._v(_vm._s(entrega.platosSerialized))])]), _vm._v(" "), _c('td', {
        staticClass: "td-status"
      }, [_c('select-estados', {
        attrs: {
          "identrega": entrega._id,
          "estadoorigen": entrega.estado
        },
        on: {
          "change-estado": _vm.onChangeItemEstado
        }
      })], 1), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('a', {
        staticClass: "btn btn-outline btn-xsw pull-right",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.abrirComanda(entrega)
          }
        }
      }, [_vm._v("DETALLE")])])])
    }))])])])])])
  })), _vm._v(" "), (_vm.entregasActivasAgrupadasHora.length === 0) ? _c('div', {
    staticClass: "text-center center-block placeholder"
  }, [_c('h1', [_vm._v("No hay pedidos en estado " + _vm._s(_vm.estados[_vm.idxEstadoActivo].text) + " para esta fecha")])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade detalle-pedido",
    attrs: {
      "id": "detalle-pedido",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [(_vm.entregaComanda) ? _c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_vm._m(13), _vm._v(" "), _c('h2', [_vm._v("Comanda #" + _vm._s(_vm.entregaComanda.numero))]), _vm._v(" "), _c('p', {
    staticClass: "size-16"
  }, [_vm._v("\n        Fecha y hora: "), _c('span', {
    staticClass: "semibold"
  }, [_vm._v(_vm._s(_vm._f("fechaComanda")(_vm.entregaComanda.fechaEntrega)))]), _c('br'), _vm._v("\n        Empresa: "), _c('span', {
    staticClass: "semibold"
  }, [_vm._v(_vm._s(_vm.entregaComanda.sucursal.empresa.razonSocial) + " - " + _vm._s(_vm.entregaComanda.sucursal.denominacion))]), _c('br'), _vm._v("\n        Empleado: "), _c('span', {
    staticClass: "semibold"
  }, [_vm._v(_vm._s(_vm.entregaComanda.usuario.displayName))]), _c('br'), _vm._v(" "), (_vm.entregaComanda.usuario.other || _vm.entregaComanda.usuario.alergic || _vm.entregaComanda.usuario.vegan || _vm.entregaComanda.usuario.vegetarian) ? _c('span', {
    staticClass: "deliveryModalRestrictions"
  }, [_c('h4', [_vm._v("TIENE RESTRICCIONES ALIMENTICIAS")]), _vm._v(" "), (_vm.entregaComanda.usuario.vegan) ? _c('span', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "icon-vegan"
  }), _vm._v(" Vegano")]) : _vm._e(), _vm._v(" "), (_vm.entregaComanda.usuario.vegetarian) ? _c('span', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "icon-vegetarian"
  }), _vm._v(" Vegetariano")]) : _vm._e(), _vm._v(" "), (_vm.entregaComanda.usuario.celiac) ? _c('span', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "icon-celiac"
  }), _vm._v(" Sin gluten")]) : _vm._e(), _vm._v(" "), (_vm.entregaComanda.usuario.other) ? _c('span', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "icon-menu-config"
  }), _vm._v(" Otros")]) : _vm._e(), _vm._v(" "), (_vm.entregaComanda.usuario.alergic) ? _c('span', {
    staticClass: "text-danger"
  }, [_c('i', {
    staticClass: "icon-spice"
  }), _vm._v(" Alérgico")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.entregaComanda.usuario.other || _vm.entregaComanda.usuario.alergic) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.entregaComanda.usuario.restrictions) + "\n          ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "order-list"
  }, _vm._l((_vm.entregaComanda.platos), function(plato) {
    return _c('li', {
      key: plato._id
    }, [_c('span', [_vm._v(_vm._s(plato.cantidad) + "x")]), _vm._v(" " + _vm._s(plato.plato.nombre))])
  }))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "comanda-general",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "body-comanda"
    }
  }, [_vm._m(14), _vm._v(" "), _c('h2', [_vm._v("Comanda general " + _vm._s(_vm._f("diaFormateado")(_vm.diaActivo)))]), _vm._v(" "), _vm._l((_vm.comandaDelDia), function(item, idx) {
    return [_c('h3', [_vm._v(_vm._s(idx))]), _vm._v(" "), _c('ul', {
      staticClass: "order-list"
    }, _vm._l((item), function(plato) {
      return _c('li', {
        key: plato._id
      }, [_c('span', [_vm._v(_vm._s(plato.cantidad) + "x")]), _vm._v(" " + _vm._s(plato.plato.nombre) + "\n              ")])
    }))]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-fill",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.imprimirComandaGeneral($event)
      }
    }
  }, [_vm._v("Imprimir")])])])])])]), _vm._v(" "), _c('iframe', {
    staticStyle: {
      "height": "0px",
      "width": "0px",
      "position": "absolute"
    },
    attrs: {
      "id": "ifmcontentstoprint"
    }
  }), _vm._v(" "), _c('div', {
    ref: "contenedorExport",
    staticClass: "hidden"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "contenedorEtiquetas"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header-lg"
  }, [_c('i', {
    staticClass: "icon-stats"
  }), _c('h1', [_vm._v(" RESUMEN")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-8"
  }, [_c('span', {
    staticClass: "stats-label"
  }, [_vm._v("Pedidos"), _c('br'), _vm._v("Pendientes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-8"
  }, [_c('span', {
    staticClass: "stats-label"
  }, [_vm._v("Pedidos"), _c('br'), _vm._v("en Curso")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-8"
  }, [_c('span', {
    staticClass: "stats-label"
  }, [_vm._v("Pedidos"), _c('br'), _vm._v("Procesados")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-8"
  }, [_c('span', {
    staticClass: "stats-label"
  }, [_vm._v("Pedidos"), _c('br'), _vm._v("Despachados")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-8"
  }, [_c('span', {
    staticClass: "stats-label"
  }, [_vm._v("Pedidos"), _c('br'), _vm._v("Cancelados")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-aside-body text-center"
  }, [_c('a', {
    staticClass: "btn btn-fill",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#comanda-general"
    }
  }, [_vm._v("Comanda del día")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-lg"
  }, [_c('i', {
    staticClass: "icon-status"
  }), _vm._v(" Cambiar estados")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-lg"
  }, [_c('i', {
    staticClass: "icon-export"
  }), _vm._v(" Exportar lista")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-outline-grey-green dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown",
      "aria-expanded": "true"
    }
  }, [_vm._v("\n                        EXCEL  "), _c('i', {
    staticClass: "fa fa-angle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-outline-grey-green dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown",
      "aria-expanded": "true"
    }
  }, [_vm._v("\n                         PDF "), _c('i', {
    staticClass: "fa fa-angle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-lg"
  }, [_c('i', {
    staticClass: "icon-print"
  }), _vm._v(" Imprimir")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-lg"
  }, [_c('i', {
    staticClass: "icon-listview"
  }), _vm._v(" Filtrar")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26c3a41c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Restaurante/GestorEntregas.vue
// module id = 1113
// module chunks = 5